import { useState, useEffect, useRef } from "react";
import { TableContainer, Paper, Typography, Box, Button } from "@mui/material";
import PaginationBox from "../../../Components/Masters/Pagination";
import ColumnHeadings from "../../../Components/Masters/ColumnHeadings";
import TableContent from "../../../Components/Masters/TableContent";
import TableHeading from "../../../Components/Masters/TableHeading";
import NoDataFound from "../../../Components/Masters/NoDataFound";
import { useUser } from "../../../context/AuthContext";

const ReceivedRequest = ({
  data = [],
  columnHeadings = [],
  user,
  /* pagination & sorting info from parent */
  page,
  totalPages,
  rowsPerPage,
  sortConfig,
  /* event callbacks to parent */
  onPageChange,
  /* misc callbacks */
  handleMenuClick1,
  isShortContent,
  handleAction,
  handleSort,
}) => {
  const [sortConfig1, setSortConfig] = useState({
    key: "createdAt",
    direction: "desc",
  });
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {}, [page, rowsPerPage, sortConfig, searchQuery]);

  const tableContainerRef = useRef(null); // Reference to the table container
  const [isShortContent1, setIsShortContent] = useState(false);

  useEffect(() => {
    const container = tableContainerRef.current;

    if (container) {
      const tableHeight = container.scrollHeight; // Get the table's height
      const screenHeight = window.innerHeight; // Get the viewport height

      // If table content is less than half the screen height, set pagination to be at the bottom
      setIsShortContent(tableHeight < screenHeight / 1.5);
    }
  }, [data]);

  return (
    <Box
      sx={{
        // padding: "20px",
        backgroundColor: "#ededed",
        width: "100%",
      }}
    >
      <TableContainer
        component={Paper}
        sx={{ maxWidth: "100%" }}
        ref={tableContainerRef}
      >
        <Box>
          <TableHeading heading={"Request Emission Data"} />
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "11% 15% 14% 14% 15% 14% 17%",
              borderBottom: "1px solid #ddd",
              borderTop: "1px solid #ddd",
            }}
          >
            {columnHeadings.map((el) => (
              <ColumnHeadings
                key={el.fieldName}
                {...{
                  title: el.title,
                  handleSort,
                  field: el.fieldName,
                  sortConfig,
                }}
                // handleSort={() => onSort(el.fieldName)}
              />
            ))}
            <Typography
              sx={{
                fontWeight: "bold",
                padding: "8px 12px",
                textAlign: "center",
              }}
            >
              Action
            </Typography>
          </Box>
          {data.length === 0 ? (
            <NoDataFound />
          ) : (
            data.map((item) => (
              <Box
                key={item._id}
                sx={{
                  display: "grid",
                  gridTemplateColumns: "11% 15% 14% 14% 15% 14% 17%",
                  borderBottom: "1px solid #ddd",
                }}
              >
                {columnHeadings.map((el) => {
                  let displayValue;

                  // Handle special cases for specific fields
                  if (el.fieldName === "partnerCompany") {
                    displayValue = item.company?.companyName || "N/A";
                  } else if (el.fieldName === "industry") {
                    displayValue = item.company?.industry || "N/A";
                  } else if (el.fieldName === "contactPersonName") {
                    displayValue = item.createdByUser?.name || "N/A";
                  } else if (el.fieldName === "contactNumber") {
                    displayValue = `${item.facility?.countryCode || ""} ${
                      item.facility?.phone || ""
                    }`.trim();
                  } else {
                    // Default case for other fields
                    displayValue = item[el.fieldName] || "N/A";
                  }

                  return (
                    <TableContent
                      key={el.fieldName}
                      {...{
                        fieldData: displayValue,
                        dateField: el.fieldName === "createdAt" ? item.createdAt : false,
                      }}
                    />
                  );
                })}

                <Box sx={{ display: "flex", justifyContent: "center", gap: 1 }}>
                  {item.action &&
                  (item.action === "Accepted" || item.action === "Rejected") ? (
                    // Display the saved status as text
                    <Typography
                      sx={{
                        fontSize: "14px",
                        marginTop: "9px",
                        alignItems: "left",
                        color: item.action === "Accepted" ? "black" : "black",
                      }}
                    >
                      {item.action}
                    </Typography>
                  ) : (
                    // Render action buttons if no status or action is not yet set
                    <>
                      <Button
                        variant="contained"
                        size="small"
                        onClick={() => handleAction("Accepted", item._id)}
                        sx={{
                          backgroundColor: "#1c486b",
                          color: "white",
                          fontSize: "12px",
                          fontWeight: "bold",
                          textTransform: "capitalize",
                          padding: "0px 16px",
                          borderRadius: "4px",
                          boxShadow: "none",
                          marginTop: "2.5%",
                          height: "78%",
                          lineHeight: "1",
                          "&:hover": {
                            backgroundColor: "#042036",
                          },
                        }}
                      >
                        Accept
                      </Button>
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={() => handleAction("Rejected", item._id)}
                        sx={{
                          borderColor: "#052450",
                          color: "#052450",
                          fontSize: "12px",
                          fontWeight: "bold",
                          textTransform: "capitalize",
                          padding: "0px 16px",
                          borderRadius: "4px",
                          boxShadow: "none",
                          marginTop: "2.5%",
                          height: "78%",
                          lineHeight: "1",
                          "&:hover": {
                            backgroundColor: "#f4f4f4",
                            borderColor: "#042036",
                          },
                        }}
                      >
                        Reject
                      </Button>
                    </>
                  )}
                </Box>
              </Box>
              // </Box>
            ))
          )}
        </Box>
      </TableContainer>
      {/* Pagination */}
      {totalPages > 1 && (
        <PaginationBox
          isShortContent={isShortContent}
          totalPages={totalPages}
          page={page}
          handleChangePage={onPageChange}
          rowsPerPage={rowsPerPage}
        />
      )}
    </Box>
  );
};

export default ReceivedRequest;
